/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodNeutral = createReactComponent("outline", "mood-neutral", "IconMoodNeutral", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }]]);

export { IconMoodNeutral as default };
//# sourceMappingURL=IconMoodNeutral.mjs.map
